const AppKey = 'GloopApp';
const UserKeyPrefix  = 'User-';
const GloopCollectionKey = 'Gloops'

const getUserKey = () =>{
	return UserKeyPrefix + (window.UserId ? window.UserId : 0);
}

const getData = () => {
	if(window.localStorage && window.localStorage.hasOwnProperty(AppKey)){
		return JSON.parse(window.localStorage[AppKey]);
	}
}

const saveData = (Userdata) => {
	if(window.localStorage){
		let data = getData();
		if (!data) {
			data = {};
		}
		data[getUserKey()] = Userdata;
		window.localStorage[AppKey] = JSON.stringify(data);
	}
}




export const getUserData = (id) =>{
	const data =getData();
	if(data){
		return data[getUserKey()];
	}
	return null;
}

export const getLocalGloops = () => {
	const data = getUserData();
	let output = {};
	if(!data || !data[GloopCollectionKey]){
		return {};
	}else {
		for(let key in data[GloopCollectionKey]){
			output[key] = {
				id : key,
				status : 'loaded',
				data : data[GloopCollectionKey][key]
			}
		}
		return output;
	}

}

export const getGloopData = (id) => {
	const data = getUserData();
	if(data && data[GloopCollectionKey]){
		return data[GloopCollectionKey][id];
	}
	return null;
}

export const saveGloopData = (gloopData) => {
	let data = getUserData();
	if(!data) {
		data = {};
	}
	let colection = data[GloopCollectionKey] ? data[GloopCollectionKey] : {};
	let oldGloop = colection[gloopData.id] ? colection[gloopData.id] : {}
	let newGloop = Object.assign({},oldGloop,gloopData.data);

	// data[GloopCollectionKey] = Object.assign(
	// 	colection,
	// 	{[gloopData.id] :newGloop}
	// 	);
	data[GloopCollectionKey] = {[gloopData.id] :newGloop};
	saveData(data);
}